var _defs, _g, _ellipse, _ellipse2, _ellipse3, _ellipse4, _g2, _line, _path, _polygon, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _rect, _line2, _path17, _path18, _path19, _path20, _line3, _path21, _path22, _path23, _path24, _path25, _path26, _rect2, _rect3, _rect4, _ellipse5, _path27, _ellipse6, _ellipse7, _ellipse8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCouch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_4",
    xmlns: "http://www.w3.org/2000/svg",
    width: 318,
    height: 181,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 318 181",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-3,.cls-4{fill:none;}.cls-5{fill:url(#pattern-1);}.cls-6{fill:#fff;}.cls-7{fill:#f59db6;}.cls-8{fill:#fccdd3;}.cls-9{fill:#bbc4ef;}.cls-10{fill:#b29ffa;}.cls-11{fill:#e1e7f9;}.cls-12{fill:#d5dcf3;}.cls-13{fill:#52d2bc;}.cls-14,.cls-15{fill:#6535ff;}.cls-16,.cls-17{fill:#5e58a5;}.cls-15{opacity:.19;}.cls-15,.cls-18{isolation:isolate;}.cls-17,.cls-2,.cls-4{stroke-width:.5px;}.cls-17,.cls-3,.cls-4{stroke:#2e2a47;stroke-miterlimit:10;}.cls-2{stroke:#473e6b;stroke-linecap:round;stroke-linejoin:round;}.cls-3{stroke-width:.25px;}.cls-19{fill:#2e2a47;opacity:.3;}"), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern-1",
    x: 0,
    y: 0,
    width: 50,
    height: 50,
    patternTransform: "translate(-20 -15940) scale(1 -1)",
    patternUnits: "userSpaceOnUse",
    viewBox: "0 0 50 50"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 50,
    height: 50
  }), /*#__PURE__*/React.createElement("image", {
    id: "image-2",
    className: "cls-18",
    width: 100,
    height: 100,
    transform: "translate(10 66) scale(.5 -.5)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAABYlAAAWJQFJUiTwAAACuUlEQVR4Xu3ZMW4dMQwE0Pm/dZ37pc+lcr/UqTeF8eM1vKI4tERQq5leDwSm0zwO4BeA3ziOv4jm8XgD8BPADwB/II/LyXscwNsoDIOPw4be4zgO+4GVycdhQ+9pPrCScNyOXqyQpOPMN1YW9vhCEo8LZXGPKyT5ODo38PyFODAq8i49XyFOzB15Ta9fCIG5Is/07EJIrBt5Xa9dSAAzI8/lXRcSxJqR5/a+FvIN7DLyKO9zId/EvkQe7X0UMgD7FHkh772QQdj/yAt773vIIAzA0OMAbOc9MRAbfdyO3hMDMQw+Dht6TwzEMPg4bOhpU2cz2dOmziTB6//2tpJw3I5erJCk48w3Vhb2+EISjwtlcY8rJPk4Ojfw/IU4MCryLj1fIU7MHXlNr18Igbkiz/S0qZ9TwNOm/koRT5s6UMrTpl7M06ZezNOmXszTpl7M06ZezNOmXszTph7NJE+beiQTPW3qbCZ72tSZJHj9395WEo7b0YsVknSc+cbKwh5fSOJxoSzucYUkH0fnBp6/EAdGRd6l5yvEibkjr+n1CyEwV+SZnjb1cwp42tRfKeJpUwdKedrUi3na1It52tSLedrUi3na1It52tSLedrUo5nkaVOPZKKnTZ3NZE+bOpMEr//b20rCcTt6sUKSjjPfWFnY4wtJPC6UxT2ukOTj6NzA8xfiwKjIu/R8hTgxd+Q1vX4hBOaKPNPTpn5OAU+b+itFPG3qQClPm3oxT5t6MU+bejFPm3oxT5t6MU+bejFPm3o0kzxt6pFM9LSps5nsaVNnkuD1f3tbSThuRy9WSNJx5hsrC3t8IYnHhbK4xxWSfBydG3j+QhwYFXmXnq8QJ+aOvKbXL4TAXJFnetrUzyngaVN/pYinTR0o5WlTL+ZpUy/maVMv5mlTL+ZpUy/maVMv5mlTj2aS9w+PFcz0wSspPwAAAABJRU5ErkJggg=="
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "app-Mobile"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d-07",
    transform: "translate(-561.000000, -265.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Asset-4",
    transform: "translate(561.000000, 265.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    className: "cls-12",
    d: "M100,10H3V5H100v5ZM3.44,9.62H99.56V5.38H3.44v4.23Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    className: "cls-12",
    y: 0,
    width: 104,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    className: "cls-12",
    x: 2,
    y: 3,
    width: 99,
    height: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    className: "cls-11",
    d: "M104,102H0v-3H104v3ZM.65,101.18H103.35v-1.37H.65v1.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-3",
    className: "cls-11",
    d: "M98.93,105H4.07c-1.14,0-2.07-1.16-2.07-2.59v-.41H101v.41c0,1.43-.93,2.59-2.07,2.59ZM2.72,102.82c.15,.8,.72,1.37,1.37,1.37H98.93c.66,0,1.23-.57,1.38-1.37H2.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-4",
    className: "cls-11",
    d: "M10,10V99H92V10H10ZM89.58,96.38H12.42V12.62H89.58V96.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-5",
    className: "cls-11",
    d: "M18,110h-7v-7h7v7Zm-6.29-.75h5.59v-5.51h-5.59v5.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-6",
    className: "cls-11",
    d: "M87,110h-7v-7h7v7Zm-6.3-.75h5.6v-5.51h-5.6v5.51Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-3",
    className: "cls-11",
    x: 50,
    y: 55,
    width: 3,
    height: 41
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    className: "cls-12",
    d: "M94.76,67.71l-86.32,6.29c-.37,.03-.74-.1-1.01-.35-.27-.25-.43-.6-.43-.96V11H96v55.4c0,.69-.54,1.26-1.24,1.31h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    className: "cls-6",
    d: "M27.46,83c-.12,0-.24-.05-.33-.14-.18-.18-.18-.47,0-.65l7.06-7.07c.18-.18,.48-.19,.66,0s.19,.48,0,.66l-7.08,7.07c-.08,.09-.2,.13-.32,.14h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-3",
    className: "cls-6",
    d: "M26.43,90c-.11,0-.22-.05-.3-.13-.17-.17-.17-.44,0-.61l11.15-11.15c.17-.16,.43-.15,.6,.01,.16,.16,.17,.43,.01,.6l-11.15,11.15c-.08,.08-.19,.12-.3,.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-4",
    className: "cls-6",
    d: "M67.46,85c-.12,0-.24-.05-.32-.13-.18-.18-.18-.47,0-.65l10.1-10.09c.18-.17,.46-.16,.64,.01,.17,.17,.18,.46,.01,.64l-10.1,10.09c-.09,.08-.2,.13-.32,.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-5",
    className: "cls-6",
    d: "M68.4,90c-.11,0-.21-.04-.28-.12-.16-.16-.16-.41,0-.57l3.21-3.21c.16-.15,.4-.14,.56,0,.15,.15,.16,.4,0,.56l-3.21,3.21c-.08,.08-.18,.12-.28,.12h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-7",
    className: "cls-12",
    d: "M263,10h-97V5h97v5Zm-96.56-.38h96.12V5.38h-96.12v4.23Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-4",
    className: "cls-12",
    x: 163,
    y: 0,
    width: 104,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-5",
    className: "cls-12",
    x: 165,
    y: 3,
    width: 99,
    height: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-8",
    className: "cls-11",
    d: "M267,102h-104v-3h104v3Zm-103.35-.82h102.69v-1.37h-102.69v1.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-9",
    className: "cls-11",
    d: "M261.93,105h-94.86c-1.14,0-2.07-1.16-2.07-2.59v-.41h99v.41c0,1.43-.93,2.59-2.07,2.59Zm-96.21-2.18c.15,.8,.72,1.36,1.38,1.37h94.83c.66,0,1.23-.57,1.37-1.37h-97.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-10",
    className: "cls-11",
    d: "M173,10V99h82V10h-82Zm79.58,86.38h-77.17V12.62h77.17V96.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-11",
    className: "cls-11",
    d: "M181,110h-7v-7h7v7Zm-6.3-.76h5.6v-5.52h-5.6v5.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-12",
    className: "cls-11",
    d: "M250,110h-7v-7h7v7Zm-6.3-.76h5.6v-5.52h-5.6v5.52Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-6",
    className: "cls-11",
    x: 212,
    y: 55,
    width: 3,
    height: 41
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-6",
    className: "cls-12",
    d: "M256.71,63h-84.42c-1.26,0-2.29-1.02-2.29-2.27V10h89V60.76c-.02,1.24-1.04,2.24-2.29,2.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-7",
    className: "cls-6",
    d: "M190.47,83c-.19,0-.36-.11-.43-.28s-.03-.37,.1-.51l7.07-7.07c.12-.12,.29-.16,.45-.12,.16,.04,.29,.17,.33,.33s0,.33-.12,.45l-7.07,7.07c-.09,.09-.2,.14-.33,.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-8",
    className: "cls-6",
    d: "M222.43,89c-.11,0-.22-.04-.3-.13-.08-.08-.13-.19-.13-.3s.05-.22,.13-.3l11.13-11.13c.11-.11,.27-.16,.42-.12,.15,.04,.27,.16,.31,.31,.04,.15,0,.31-.12,.42l-11.13,11.13c-.08,.08-.19,.13-.3,.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-9",
    className: "cls-6",
    d: "M230.46,85c-.12,0-.24-.05-.32-.13-.09-.09-.14-.2-.14-.32s.05-.24,.14-.32l10.08-10.08c.12-.12,.28-.16,.44-.12s.28,.17,.33,.32c.04,.16,0,.33-.12,.44l-10.09,10.08c-.08,.08-.2,.13-.32,.13h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-10",
    className: "cls-6",
    d: "M183.4,87c-.11,0-.21-.04-.28-.12-.08-.07-.12-.18-.12-.28s.04-.21,.12-.28l3.2-3.2c.16-.16,.41-.16,.56,0,.08,.07,.12,.18,.12,.28s-.04,.21-.12,.28l-3.2,3.2c-.07,.08-.18,.12-.28,.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-11",
    className: "cls-12",
    d: "M74,73.29l16.75,65.71h175.25l-26.21-31.24-8.95-31.57c-.7-2.48-2.97-4.2-5.55-4.19l-151.29,1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-12",
    className: "cls-9",
    d: "M4.05,169H316.87c.39-.02,.75,.18,.96,.52,.21,.34,.23,.78,.05,1.14-.18,.36-.52,.6-.91,.62-36.82,3.71-113.22,10.44-171.75,9.65-56.48-.77-112.96-6.4-141.3-9.65-.56-.08-.96-.61-.93-1.2s.48-1.07,1.05-1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-13",
    className: "cls-10",
    d: "M266,164h-36v-52.8c0-2.87,2.33-5.2,5.21-5.2h30.79v58Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-14",
    className: "cls-10",
    d: "M289.15,115.78l-5.22-12.05c-.54-.93-1.52-1.57-2.65-1.73h-.04c-.95,0-1.81,.54-2.17,1.37l-5.22,12.05c-2.38,5.49-2.46,11.62-.23,17.16l5.48,13.64c.51,.96,1.49,1.62,2.62,1.78h0c.98,0,1.85-.57,2.19-1.42l5.48-13.64c2.23-5.55,2.14-11.67-.23-17.16h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-15",
    className: "cls-15",
    d: "M289.52,132.31c2.04-5.56,1.96-11.7-.22-17.2l-4.01-10.11-3.7,7.52c-1.37,2.8-1.58,6.05-.57,9l1.35,3.96c.14,.4,.11,.85-.07,1.23l-2.13,4.41c-1.8,3.71-1.53,8.12,.73,11.57l2.81,4.31c.36-.25,.63-.61,.78-1.02l5.02-13.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-16",
    className: "cls-8",
    d: "M294.94,121.55h0c1.03-2.97,.82-6.23-.58-9.04l-3.24-6.51c-.61-1.23-1.86-2-3.22-2h0c-.6,0-1.16,.34-1.43,.88l-3.8,7.63c-1.4,2.81-1.61,6.07-.58,9.04l1.38,3.98c.14,.41,.11,.85-.08,1.24l-2.19,4.43c-1.84,3.73-1.56,8.16,.75,11.62l3.61,5.46c.3,.45,.8,.72,1.33,.71h3.22c.53,0,1.03-.27,1.33-.71l3.61-5.46c2.3-3.46,2.58-7.9,.74-11.62l-.32-.66c-1.37-2.8-1.56-6.04-.53-8.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-17",
    className: "cls-6",
    d: "M286.38,147s-.09,0-.13,0c-.09-.03-.17-.09-.21-.17-.04-.08-.04-.17,0-.25,1.59-3.36,2.27-6.99,1.98-10.61-.12-1.18-.36-2.34-.72-3.49-.52-1.55-.7-3.16-.54-4.77,.12-1.2,.38-2.38,.76-3.54,.46-1.36,.71-2.77,.74-4.18,.04-1.9-.25-3.79-.86-5.61-.03-.16,.08-.32,.27-.37,.19-.05,.38,.04,.46,.19,.63,1.89,.93,3.85,.88,5.81-.04,1.47-.3,2.92-.77,4.33-.36,1.12-.61,2.27-.73,3.43-.15,1.53,.02,3.08,.52,4.56,.36,1.17,.6,2.36,.73,3.57,.3,3.72-.39,7.45-2.02,10.9-.06,.12-.2,.19-.34,.19h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-7",
    className: "cls-10",
    d: "M275,145h21c1.1,0,2,.9,2,2h0c0,1.1-.9,2-2,2h-21c-1.1,0-2-.9-2-2h0c0-1.1,.9-2,2-2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-18",
    className: "cls-10",
    points: "291.67 172 277.16 172 275 151 296 151 291.67 172"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-19",
    className: "cls-12",
    d: "M277,164v-50.31c0-2.04-.82-4-2.27-5.44-1.46-1.44-3.43-2.25-5.49-2.25h-8.47c-2.06,0-4.04,.81-5.49,2.25-1.46,1.44-2.27,3.4-2.27,5.44v50.31h24Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-20",
    className: "cls-10",
    d: "M73.58,122l-5.07-12.41s-3.08-9.57-3.97-13.27c-.6-2.44-1.19-6.04-1.49-8.18-.18-1.16,.13-2.34,.86-3.27l8.13-10.32c.32-.4,.83-.6,1.34-.53,.51,.07,.94,.4,1.14,.87l16.48,39.96-17.42,7.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-21",
    className: "cls-10",
    d: "M108,164h-42v-52.8c0-2.87,2.36-5.2,5.26-5.2h36.74v58Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-22",
    className: "cls-12",
    d: "M120,164v-50.31c0-2.04-.82-4-2.27-5.44-1.46-1.44-3.43-2.25-5.49-2.25h-8.47c-4.29,0-7.77,3.44-7.77,7.69v50.31h24Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-8",
    className: "cls-12",
    x: 187,
    y: 130,
    width: 66,
    height: 18
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-9",
    className: "cls-12",
    x: 120,
    y: 148,
    width: 134,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-10",
    className: "cls-12",
    x: 120,
    y: 130,
    width: 66,
    height: 18
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-23",
    className: "cls-14",
    d: "M119.62,130c-.11,0-.21-.05-.28-.13-.08-.08-.12-.2-.12-.31v-15.15c0-4.15-3.05-7.52-6.82-7.52-.22,0-.4-.2-.4-.44s.18-.44,.4-.44c4.19,.02,7.58,3.76,7.6,8.38v15.2c-.01,.23-.17,.41-.38,.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-24",
    className: "cls-6",
    d: "M119.5,165c-.13,0-.26-.04-.35-.12-.09-.08-.15-.18-.15-.29v-17.17c0-.23,.22-.42,.5-.42s.5,.19,.5,.42v17.17c0,.23-.22,.42-.5,.42h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-25",
    className: "cls-10",
    d: "M265.5,172h0c-1.38,0-2.5-1.18-2.5-2.63v-5.37h5v5.35c0,.7-.25,1.38-.72,1.88s-1.11,.78-1.78,.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-26",
    className: "cls-10",
    d: "M224.5,172h0c-.67,0-1.31-.28-1.78-.78-.47-.5-.73-1.17-.72-1.87v-5.35h5v5.35c0,1.45-1.12,2.62-2.5,2.62v.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-27",
    className: "cls-10",
    d: "M103.93,172h0c-1.38,0-2.5-1.18-2.5-2.63v-5.37h5v5.35c0,.7-.25,1.38-.72,1.88s-1.11,.78-1.78,.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-28",
    className: "cls-10",
    d: "M75.53,170.67h0c-.67,0-1.32-.27-1.8-.77-.48-.5-.74-1.18-.73-1.88v-5.35h5v5.35c.01,1.45-1.09,2.63-2.47,2.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-29",
    className: "cls-6",
    d: "M252.5,136c-.13,0-.26-.04-.35-.12-.09-.08-.15-.18-.15-.29v-17.17c0-.23,.22-.41,.5-.41s.5,.19,.5,.41v17.17c0,.23-.22,.41-.5,.41h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-30",
    className: "cls-6",
    d: "M226.57,149h-40.14c-.24,0-.43-.22-.43-.5s.19-.5,.43-.5h40.14c.24,0,.43,.22,.43,.5s-.19,.5-.43,.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-31",
    className: "cls-6",
    d: "M179.57,149h-40.14c-.24,0-.43-.22-.43-.5s.19-.5,.43-.5h40.14c.24,0,.43,.22,.43,.5s-.19,.5-.43,.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-32",
    className: "cls-10",
    d: "M234.55,91c-.2,0-.37-.13-.43-.31l-4.65-15.7c-.56-1.86-2.34-3.14-4.37-3.15h-17.66c-.25,0-.44-.19-.44-.42s.2-.42,.44-.42h17.66c2.42,0,4.55,1.54,5.22,3.77l4.66,15.7c.07,.22-.07,.46-.31,.52l-.13,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-33",
    className: "cls-6",
    d: "M252.5,157c-.13,0-.26-.05-.35-.13-.09-.08-.15-.19-.15-.31v-8.12c0-.24,.22-.44,.5-.44s.5,.2,.5,.44v8.12c0,.24-.22,.44-.5,.44Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-11",
    className: "cls-12",
    x: 31,
    y: 62,
    width: 4,
    height: 104
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-12",
    className: "cls-15",
    x: 32,
    y: 62,
    width: 1,
    height: 104
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-34",
    className: "cls-5",
    d: "M44.97,83c-2.45-2.87-3.22-5.17-2.29-6.8,.46-.72,1.17-1.32,2.04-1.7,.63-.24,1.14-.66,1.44-1.19,.58-1.42-1.55-3.77-6.15-6.8l.46-.5c5.02,3.3,7.11,5.75,6.41,7.49-.35,.66-.97,1.2-1.74,1.52-.76,.32-1.38,.83-1.78,1.45-.81,1.43-.06,3.51,2.23,6.19l-.59,.35Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-35",
    className: "cls-10",
    points: "57 70 13 70 20.04 36 50.4 36 57 70"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-36",
    className: "cls-10",
    d: "M53,170H17c2.7-3.15,6.96-5,11.49-5h13.02c4.53,0,8.79,1.86,11.48,5h.01Z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    className: "cls-10",
    cx: 45.5,
    cy: 83.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-37",
    className: "cls-14",
    d: "M31.5,124c-.2,0-.37-.1-.37-.21v-19.57c0-.12,.17-.21,.37-.21,.2,0,.36,.1,.37,.21v19.57c0,.12-.17,.21-.37,.21h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-38",
    className: "cls-14",
    d: "M31.48,93c-.2,0-.37-.1-.37-.22v-15.55c0-.12,.17-.22,.37-.22,.11,0,.21,.01,.29,.06s.13,.1,.13,.17v15.55c0,.06-.05,.12-.13,.17s-.19,.06-.29,.06h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-39",
    className: "cls-14",
    d: "M38.57,164.98h-3.16c-.23,0-.41-.17-.41-.38v-3.22c0-.21,.18-.38,.41-.38s.41,.17,.41,.38v2.86h2.77c.23,0,.41,.17,.41,.38s-.18,.38-.41,.38l-.02-.02Z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    className: "cls-12",
    cx: 130.5,
    cy: 36.5,
    r: 14.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-3",
    className: "cls-11",
    cx: 131,
    cy: 37,
    r: 12
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-13",
    className: "cls-8",
    x: 131,
    y: 36,
    width: 8,
    height: 1
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-14",
    className: "cls-8",
    points: "131.5 36.5 131.5 44.5 130.5 44.5 130.5 36.5 131.5 36.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-40",
    className: "cls-6",
    d: "M186.5,149c-.13,0-.26-.05-.35-.13-.09-.08-.15-.19-.15-.31v-12.13c0-.24,.22-.43,.5-.43s.5,.19,.5,.43v12.13c0,.11-.05,.22-.15,.31-.09,.08-.22,.13-.35,.13Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-4",
    className: "cls-15",
    cx: 113.29,
    cy: 176.17,
    rx: 8,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-5",
    className: "cls-15",
    cx: 62,
    cy: 171.5,
    rx: 8,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-6",
    className: "cls-15",
    cx: 55.5,
    cy: 174,
    rx: 12.5,
    ry: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-7",
    className: "cls-10",
    cx: 96,
    cy: 173.5,
    rx: 2,
    ry: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-8",
    className: "cls-10",
    cx: 88.5,
    cy: 177,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-9",
    className: "cls-10",
    cx: 95.5,
    cy: 170,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-10",
    className: "cls-10",
    cx: 91.5,
    cy: 174,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-41",
    className: "cls-12",
    d: "M69.83,157.18l-1.72-3.61v-2.57h-3.18v2.57l-1.72,3.61c-.14,.29-.21,.61-.21,.93v13.53c0,.75,.61,1.36,1.35,1.36h4.29c.75,0,1.35-.61,1.35-1.36v-13.53c.01-.32-.05-.64-.17-.93h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-42",
    className: "cls-15",
    d: "M64.8,151v2.58l-1.61,3.64c-.13,.29-.19,.62-.19,.94v12.13l.99,.71v-7.74l.4-6.24,1.61-2.58-.3-3.44h-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-43",
    className: "cls-12",
    d: "M50.18,168.17l-3.62,1.72h-2.57v3.18h2.57l3.62,1.72c.29,.14,.61,.21,.93,.21h13.53c.36,0,.71-.14,.96-.4,.26-.25,.4-.6,.4-.96v-4.3c0-.75-.61-1.35-1.36-1.35h-13.53c-.32,0-.64,.05-.93,.17h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-44",
    className: "cls-14",
    d: "M65.88,173c-.07,0-.12-.11-.12-.24v-4.95c0-.73-.29-1.32-.65-1.32-.03,0-.06-.02-.09-.07s-.03-.11-.03-.17c0-.13,.05-.24,.12-.24,.49,0,.88,.81,.88,1.8v4.95c0,.13-.05,.24-.12,.25h0Z"
  }))))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-11",
    className: "cls-10",
    cx: 168.36,
    cy: 177.36,
    rx: 2,
    ry: 1
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-12",
    className: "cls-10",
    cx: 163.88,
    cy: 173.29,
    rx: 2,
    ry: 1
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-13",
    className: "cls-10",
    cx: 121,
    cy: 176.71,
    rx: 2,
    ry: 1
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-14",
    className: "cls-10",
    cx: 185.44,
    cy: 177.17,
    rx: 2,
    ry: 1
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M134.9,70.77c-1.86,0-5.69-.2-5.69-.2l7.21,.85c-.18-.32-.6-.64-1.52-.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M129.21,70.57s3.84,.2,5.69,.2c.92,0,1.33,.32,1.52,.64l3.84,.45s-2.9-8.29-3.58-8.74c-.05-.03-.09-.1-.14-.18-.91-.03-1.96-.61-2.67-1.24,0,.17,.02,.35,.02,.52,0,0-1.12-.83-2.26-.85-1.15-.03-2.2,1-2.2,1l-1.97-4.05c-.05-.1-.2-.08-.2,.03-.13,1.63-.6,7.83-.55,8.75,.05,1.06,.29,4.44,.29,4.44,0,0-.3,1.73,1.46,1.76s5.29,0,5.29,0c0,0,.18,1.05,0,1.28-.18,.23,.03,1.1,1.23,1.05,1.2-.05,1.58-1,1.58-1.4v-2.16s.05-.33-.14-.66l-7.21-.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M147.63,71.55s.3,1.73-1.46,1.76-5.29,0-5.29,0c0,0-.18,1.05,0,1.28s-.03,1.1-1.23,1.05-1.58-1-1.58-1.4v-2.16s-.2-1.3,1.66-1.3,5.69-.2,5.69-.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M136.96,64.42s7.07-8.5,14.27-6.63,7.87,7.77,8.06,10.13-2.68,8.31-7.11,9.5-4.66,3.07-4.55,5.12,3.18,4.55,.97,5.51-2.79-1.25-3.52-3.41-2.05-6.08,1.19-7.84,4.26-1.88,5.74-2.5,2.1-1.99,2.1-1.99l-18.87,.23,.68-6.54,1.04-1.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M159.28,67.93c.19,2.36-2.68,8.31-7.11,9.5s-4.66,3.07-4.55,5.12,3.18,4.55,.97,5.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M134.98,75.63c1.2-.05,1.58-1,1.58-1.4v-2.16s.2-1.3-1.66-1.3-5.69-.2-5.69-.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M140.88,73.3s-.18,1.05,0,1.28-.03,1.1-1.23,1.05-1.58-1-1.58-1.4v-2.16s-.2-1.3,1.66-1.3,3.9-.12,3.9-.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M154.73,73.1l-9.03-.19v-1.74c0-.88,2.17-.52,2.17-.52,0,0-.3-1.98,.47-4.4s5-1.65,5-1.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M153.34,64.6s-4.23-.77-5,1.65-.47,4.4-.47,4.4c0,0-2.17-.36-2.17,.52v1.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M133.83,64.81l2.55-7.96c.04-.11,.2-.1,.21,.02l.86,9.75"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 131.78,
    cy: 65.41,
    r: 4.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 136.81,
    y1: 59.28,
    x2: 137.31,
    y2: 64.97
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 131.66,
    y1: 73.31,
    x2: 128.84,
    y2: 73.31
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 145.7,
    y1: 72.91,
    x2: 152.18,
    y2: 72.91
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M191.43,95.32s-1.85-2.15-3.45-2.74"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "188.95 101.72 186.39 96.63 185.81 94.6 186.14 93.16 186.97 92.44 187.75 92.44 190.88 94.2 189.77 96.71 188.95 101.72"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M184.75,101.58c4.47-9.93,8.97-19.93,15.18-28.87,1.87-2.69,3.94-5.33,6.67-7.13s6.26-2.68,9.35-1.59c4.17,1.46,6.43,5.88,8.03,9.99,4.56,11.69,8.01,23.57,12.37,36.02-2.44-1.2-10.14,.65-12.69,1.58s-5.82,1.45-7.63-.57c-.91-1.01-1.2-2.43-1.44-3.77l-2.73-14.72c-1.95,2.65-6.37,13.5-6.91,16.74s2.54-.67-.15,1.22c-2.9,2.04-6.8,1.58-10.3,1.01-2.92-.47-6.01-1.04-8.23-3s-3.04-5.81-1.53-6.9Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M194.32,108.04l14.66-28.27c1.29-2.48,4.92-2.22,5.83,.43l10.26,29.79"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M200.61,126.69c3.43,.3,7.24-.04,10.9,0s7.7,.85,9.88,3.79c2.02,2.72,1.86,6.43,1.61,9.81l-1.92,25.98,19.57-.33c.62-.01,1.33-.06,1.72-.55,.26-.34,.3-.79,.33-1.22,.81-13.73,1.62-27.47,1.45-41.22-.05-4.49-.39-9.42-3.49-12.67-3.46-3.62-9.06-3.84-14.07-3.82l-34.11,.13"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M223.04,171.45c-.33,1.41-.66,2.85-.57,4.29s.66,2.93,1.82,3.8c1.37,1.02,3.24,.99,4.95,.92l18.38-.8c.95-.04,1.92-.09,2.79-.47s1.62-1.19,1.64-2.14c.03-1.15-1-2.1-2.09-2.46s-2.28-.32-3.42-.48c-2.58-.36-4.99-1.85-6.47-3.99"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M125.42,99.71c3.37,1.96,5.63,5.69,5.81,9.59,.07,1.6-.21,3.27-1.12,4.59-.92,1.33-2.41,2.19-3.96,2.66s-3.18,.58-4.82,.81"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M105.29,99.11c-1.05-4.15-4.66-7.45-8.82-8.48s-8.71,.08-12.16,2.62-5.82,6.4-6.91,10.54c-1.47,5.57-.72,11.44-.49,17.2s-.21,11.9-3.59,16.57c-.39,.54-.83,1.09-.89,1.76-.12,1.57,1.99,2.39,3.52,1.98s2.83-1.5,4.39-1.75c2.86-.45,5.87,2,8.49,.78,2.14-.99,2.6-3.79,2.69-6.14,.15-3.89,.07-7.79-.25-11.67-.26-3.18-.68-6.39-.24-9.56s1.88-6.36,4.57-8.09,6.72-1.5,8.64,1.05"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M122.99,142.5l-1.14,4.38c3.87-.4,8.42-1.17,13.4-2.62,3.51-1.02,6.64-2.21,9.36-3.41"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M138.56,137.5l-15.37,2.69s4.6,27.18,4.8,28.38c.2,1.2,1.1,11.72,2.31,11.62,.89-.07,.47-4.3,.18-6.51,.36,2.43,1.2,7.39,2.04,7.32,.62-.06,.39-2.73,.06-5.07,.41,2.16,.99,4.53,1.57,4.49,.65-.05,.42-2.9,.15-5.04,.35,2.08,.96,4.77,1.74,4.68,.92-.12,.25-5.09-.19-7.77,.85,1.38,1.95,2.63,2.39,2.17,.5-.53-1.15-5.65-2.23-8.8l2.54-28.15Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M127.99,168.57c.2,1.2,1.1,11.72,2.31,11.62,.89-.07,.47-4.3,.18-6.51,.36,2.43,1.2,7.39,2.04,7.32,.62-.06,.39-2.73,.06-5.07,.41,2.16,.99,4.53,1.57,4.49,.65-.05,.42-2.9,.15-5.04,.35,2.08,.96,4.77,1.74,4.68,.92-.12,.25-5.09-.19-7.77,.85,1.38,1.95,2.63,2.39,2.17,.5-.53-1.15-5.65-2.23-8.8l2.54-28.15"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M125.42,99.71s-.89,15.34,10.72,15.11-9.17,9.11-9.17,9.11h-10.2l-.73-13.7,4.08-10.52h5.31Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M131.23,109.29c.07,1.6-.21,3.27-1.12,4.59-.92,1.33-2.41,2.19-3.96,2.66s-3.18,.58-4.82,.81"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M117.34,111.84c1.17,.73,2.7-.57,2.89-1.93s-.41-2.69-.66-4.05,.04-3.04,1.31-3.58c.99-.42,2.22,.05,3.18-.44,.91-.46,1.26-1.61,2.09-2.2,.66-.47,1.52-.51,2.31-.69s1.65-.62,1.81-1.42c.25-1.2-1.31-2.05-2.52-1.86s-2.28,.96-3.49,1.15c-3.45,.54-6.12-3.57-9.61-3.62-2.12-.03-4.02,1.55-4.94,3.46s-1.03,4.11-.98,6.23,.24,4.26-.12,6.36l8.74,2.59Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M104.88,98.66c.71,.43,1.61,.25,2.43,.19s1.83,.12,2.15,.88c.18,.42,.09,.9,0,1.35-.28,1.34-.58,2.68-.89,4.02l-3.5-.15c-.34-.01-.72-.05-.95-.3-.28-.3-.21-.78-.12-1.18,.36-1.64,.71-3.28,.88-4.81Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path-45",
    className: "cls-12",
    d: "M120.31,162.67v-50.31c0-2.04-.82-4-2.27-5.44-1.46-1.44-3.43-2.25-5.49-2.25h-8.47c-4.29,0-7.77,3.44-7.77,7.69v50.31h24Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path-46",
    className: "cls-8",
    d: "M106.75,154.42c.2,0,.88,2.03,.99,2.23,.72,1.29,.93,2.78,.59,4.21-.78,4.38-.5,8.86-1.12,13.26l2.36,1.54c.15,.11,.32,.2,.5,.27,.22,.06,.45,.09,.68,.07,3.11,0,6.22-.24,9.32-.24,.65-.19,1.29-.43,1.9-.72,.8-.37,.72-.26,.68-1.1-.05-1.3-.31-2.62-.47-3.92-.25-2.09-1.13-4.97-.51-7.01l.74-2.4c.1-.31,.18-.62,.23-.94,.13-1.04-.83-2.4-.55-3.35l.66-2.31-6.78,.63-9.22-.21Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path-47",
    className: "cls-15",
    d: "M114.74,175.93c.05-.46-.06-.93-.32-1.33-.59-.86-1.74-1.21-2.59-1.87-.63-.54-1.13-1.18-1.49-1.9-.41-.57-.55-1.27-.39-1.94,.33-.85,1.53-1.3,1.66-2.2,.12-.9-.73-1.48-.97-2.31-.15-.79,.06-1.61,.58-2.26,.51-.64,.93-1.34,1.24-2.08,.3-.77,0-1.64-.72-2.1-.43-.21-1.04-.23-1.29-.63-.1-.21-.15-.44-.13-.67-.05-.89-.24-1.76-.58-2.59l-2.98-.07c.21,0,.92,2.07,1.04,2.27,.75,1.31,.97,2.84,.62,4.29-.82,4.46-.53,9.03-1.18,13.51l2.48,1.57c.16,.12,.33,.21,.52,.28,.23,.06,.48,.09,.72,.07,1.25,.03,2.52-.01,3.79-.06Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M193.2,115.82h26.63c7.4,0,13.29,6.21,12.89,13.61l-2.05,37.83"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 219.59,
    y: 165.08,
    width: 24.58,
    height: 7.83,
    rx: 2.13,
    ry: 2.13
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 191.43,
    y1: 106.46,
    x2: 231.17,
    y2: 106.46
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M120.2,119.81c-.75-2.46,4.99-1.17,7.65-2.4s5.77-1.1,8.29-2.59c5.28-3.11,11.41-4.42,17.46-5.37s12.2-1.63,17.99-3.65c5.78-2.02,11.29-6.58,14.1-11.78,0,5.21,7.49,6.03,8.58,10.2,.54,2.08-.5,4.47,.52,6.37,1.13,2.12,4.18,2.47,5.56,4.43,1.23,1.75,.73,4.12,.31,6.21-.36,1.79-.52,3.89,.33,5.76,.15,.32-54.4-1.22-81.65,.59"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M121.85,146.88s-7.2-26.12,4.56-28.98c11.76-2.87,18.2,22.95,18.2,22.95l-22.76,6.04Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M187.98,92.58c-2.12-.78-2.53,2.02-1.93,3.43,.86,2.01,3.25,3.16,4.95,4.34,1.39,.97,2.81,2.15,3.26,3.86,.54,2.08-.5,4.47,.52,6.37,1.13,2.12,4.18,2.47,5.56,4.43,1.23,1.75,.73,4.12,.31,6.21-.36,1.79-.52,3.89,.33,5.76"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M144.48,113.99c1.4,.77,3.21-.37,4.7,.19,.43,.16,.8,.46,1.19,.7,.86,.54,1.93,.83,2.91,.58,1.63-.41,2.66-2.13,4.27-2.61,1.61-.49,3.4,.38,5.02-.1,.87-.26,1.61-.92,2.03-1.74,.17-.34,.31-.71,.61-.94,.55-.4,1.34-.09,2.01-.23,.92-.19,1.44-1.18,1.67-2.1,.09-.38,.15-.77,.15-1.16-5.02,1.42-10.26,2.03-15.43,2.85-3.14,.5-6.29,1.09-9.34,1.98-.24,.7-.66,1.4-.34,2.03,.12,.23,.32,.41,.55,.54Z"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 211.59,
    y1: 127,
    x2: 139.25,
    y2: 127
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M246.54,174.1c.64,.09,1.29,.12,1.94,.19-.64-.07-1.3-.1-1.94-.19Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M249.96,174.58c-.48-.16-.98-.24-1.48-.29-.08,.08-.16,.17-.23,.26-.39,.53-.61,1.17-.81,1.8-.13,.41-.24,.83-.24,1.27,0,.74,.35,1.41,.78,2.03,.83-.04,1.67-.12,2.42-.46,.87-.39,1.62-1.19,1.64-2.14,.03-1.15-1-2.1-2.09-2.46Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M227.51,176.95c-1.34-.86-3.03-.9-4.62-.91-.13,0-.26,0-.39,0-.01-.1-.03-.2-.03-.31,.09,1.45,.66,2.93,1.82,3.8,1.37,1.03,3.24,.99,4.95,.92l.49-.02c-.31-1.39-1.04-2.72-2.23-3.49Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M82.17,112.57c1.12-2.58,1.32-5.55,.55-8.25-.3-1.05-.74-2.06-.94-3.13-.4-2.25,.31-4.52,1.06-6.69-2.65,2.47-4.51,5.78-5.43,9.3-1.47,5.57-.72,11.44-.49,17.2,.2,5.22-.14,10.77-2.73,15.23,.96-.73,1.88-1.51,2.7-2.39,1.62-1.73,2.87-3.89,3.1-6.25,.3-3.05-1.13-6.13-.51-9.14,.44-2.12,1.84-3.9,2.7-5.88Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M218.18,127.05c-1.07-.11-2.15,.14-3.23-.05,2.54,.45,4.94,1.45,6.45,3.48,2.02,2.72,1.86,6.43,1.61,9.81-.44,5.92-.87,11.83-1.31,17.75v-.05c2.18-6.77,3.4-13.84,3.64-20.94,.07-2.2,.25-5.06-1.07-6.95-.54-.77-1.32-1.35-2.17-1.78-1.03-.52-2.17-.86-3.28-1.16-.21-.06-.42-.09-.64-.12Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M126.41,117.9c11.76-2.87,18.2,22.95,18.2,22.95"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 142.25,
    y: 174,
    width: 16.41,
    height: 3,
    rx: 0.68,
    ry: 0.68
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 142.25,
    y: 173,
    width: 16.41,
    height: 3,
    rx: 0.68,
    ry: 0.68
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 142.74,
    y: 173.29,
    width: 15.42,
    height: 2.42,
    rx: 0.59,
    ry: 0.59
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-15",
    className: "cls-15",
    cx: 201.12,
    cy: 172.5,
    rx: 12.5,
    ry: 2
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path-48",
    className: "cls-12",
    d: "M195.8,166.67l-3.62,1.72h-2.57v3.18h2.57l3.62,1.72c.29,.14,.61,.21,.93,.21h13.53c.36,0,.71-.14,.96-.4,.26-.25,.4-.6,.4-.96v-4.3c0-.75-.61-1.35-1.36-1.35h-13.53c-.32,0-.64,.05-.93,.17h0Z"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-16",
    className: "cls-12",
    cx: 141.97,
    cy: 113.32,
    rx: 1,
    ry: 0.5,
    transform: "translate(-24.22 40) rotate(-14.79)"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-17",
    className: "cls-12",
    cx: 133.82,
    cy: 116.85,
    rx: 1,
    ry: 0.5
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-18",
    className: "cls-12",
    cx: 138.66,
    cy: 115.18,
    rx: 1,
    ry: 0.5,
    transform: "translate(-32.29 58.01) rotate(-21.22)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCouch);
export default __webpack_public_path__ + "static/media/couch.22aa9814e639c263e1d659774c4d87f6.svg";
export { ForwardRef as ReactComponent };